import React from 'react';
import './index.css';
import AlertBar from '../../components/alertBar';
import Header from '../../components/header';
import BigImageSlider from '../../components/bigImageSlider';
import Menu from '../../components/menu';
import Footer from '../../components/footer';
import Articles from '../../components/articles';
import FlightsTable from '../../components/flightsTable';
import config from '../../config';
import request from 'superagent';

export default (props, routerProps) => ({
  render() {
    return (
      <div className="viewsInformation">
        <Header {...props} />
        <AlertBar showLink={true} />
        <BigImageSlider {...props} />

        <div className="padded-top-content">
          <div className="col-md-8 offset-md-2">
            <Menu menuItems={props.menuItems} />
          </div>

          <div className="col-md-8 offset-md-2 m-t-big">
            <FlightsTable />
          </div>

          <div className="col-md-8 offset-md-2 m-t-big">
            <Articles articles={props.articles} />
          </div>

          <Footer {...props} />
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/information/index.js